export function onCellKeyDown(e) {
	if (e.event.altKey && e.event.ctrlKey && e.event.code === 'KeyA') {
		gridSettings.api.setFilterModel(null);
	}

	if (e.event.shiftKey && e.event.ctrlKey && e.event.code === 'KeyA') {
		gridSettings.api.selectAllFiltered();
	}

	if (e.event.shiftKey && e.event.ctrlKey && e.event.code === 'KeyD') {
		gridSettings.api.deselectAll();
	}
}
